<template>
    <div>
        <lable>サプリ</lable>
    </div>
</template>
<script>
export default {
    
}
</script>